(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/react/components/bank-id/bank-id-start.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/react/components/bank-id/bank-id-start.js');

'use strict';

const {
  Button,
  ReactBank: Bank
} = svs.ui;
const {
  Qr,
  SelectorButtons
} = svs.iam_login.components.shared;
const {
  isPnp
} = svs.iam_login.data;
const isMobile = svs.core.detect.formfactor.mobile();
const login = svs.iam_login.utils.Login;
const {
  Loader
} = svs.components.ReactLoader;
const {
  useState
} = React;
const {
  useAtomValue
} = jotai;
const {
  activeMethodAtom
} = svs.iam_login.atoms;
const {
  abortUrl
} = svs.iam_login.data;
const BankIdStart = _ref => {
  let {
    showQR,
    isNewCustomer
  } = _ref;
  const activeMethod = useAtomValue(activeMethodAtom);
  const [showAppLoader, setShowAppLoader] = useState(false);
  const handleClick = () => {
    if (showQR) {
      login.startBankIdSameDevice(isNewCustomer);
      setShowAppLoader(true);
    } else {
      login.start(activeMethod.isFreja, isNewCustomer);
    }
  };
  return React.createElement("div", {
    className: isPnp ? 'momang' : ''
  }, showAppLoader ? React.createElement("div", {
    className: "spinner-container margin-bottom-1"
  }, React.createElement("p", {
    className: "spinner-container-text"
  }, "F\xF6rs\xF6ker starta BankID-appen"), React.createElement(Loader, null)) : React.createElement("div", null, React.createElement(SelectorButtons, null), showQR && React.createElement(Qr, {
    isNewCustomer: isNewCustomer,
    isPnp: isPnp
  }), React.createElement("div", {
    className: "login-buttons-container"
  }, React.createElement(Button, {
    block: true,
    className: "margin-top-1 margin-bottom-1",
    focus: isMobile,
    iconPosition: "left",
    inverted: !isPnp,
    onClick: handleClick,
    size: 300
  }, React.createElement(Bank, {
    height: 24,
    name: activeMethod.icon
  }), showQR ? "Starta ".concat(activeMethod.methodName, " p\xE5 den h\xE4r enheten") : "Starta ".concat(activeMethod.methodName)))), React.createElement(Button, {
    block: true,
    className: "",
    onClick: () => {
      window.location.href = abortUrl || '/';
      setShowAppLoader(false);
    },
    size: 300,
    transparent: true
  }, "Avbryt"));
};
svs.iam_login.components.bank_id.BankIdStart = BankIdStart;

 })(window);